<template>
<transition name='fast-fade'>
<div
  v-if='ready'
  ref='activity-overlay'
  class='part-quiz'
  :class='main_class'
>
  <component
    :is='"quiz-" + current_question_type'
    v-if='!is_quiz_finished'
    :label="label"
    :activity_results="activity_results"
    :question="current_question"
    :options="current_question_options"
    :nextQuestion="nextQuestion"
    :is_question_last="is_question_last"
  />

  <template v-else>
    <self-assessment-results
      v-if='current_question_type === "self-assessment"'
      :activity_results="activity_results"
      :quiz="quiz"
      :finishQuiz="finish"
      :retakeQuiz="retakeQuiz"
    />

    <quiz-results
      v-else
      :activity_results="activity_results"
      :quiz="quiz"
      :finishQuiz="finish"
      :retakeQuiz="retakeQuiz"
    />
  </template>

  <quiz-pagination
    v-if="!is_quiz_finished"
    :questions='questions'
    :question_index='question_index'
  />
</div>
</transition>
</template>

<script>
import QuizMultipleChoice from './quiz-v1-multiple-choice'
import QuizMultipleSelect from './quiz-v1-multiple-select'
import QuizSelfAssessment from './quiz-v1-self-assessment'
import QuizPagination from './quiz-v1-pagination'
import QuizResults from './quiz-v1-results'
import SelfAssessmentResults from './quiz-v1-self-assessment-results'

export default {
  props: [
    'slide_result',
    'quiz', // activity object
    'finish',
    'updateResult'
  ],

  data() {
    return {
      ready: false,
      completion_event: 'finished',
      question_index: 0,
      results_data: {},
      steps: [
        'questions',
        'results'
      ],
      step_index: null,
      activity_results: {}
    }
  },

  created() {
    this.ready = true
  },

  mounted() {
    if (this.slide_result.status === 'passed' && Object.keys(this.slide_result.results).length) {
      // deep copy
      this.activity_results = JSON.parse(JSON.stringify(this.slide_result.results))
      this.step_index = 1
    } else {
      this.step_index = 0
    }
  },

  components: {
    QuizMultipleChoice,
    QuizMultipleSelect,
    QuizSelfAssessment,
    QuizPagination,
    QuizResults,
    SelfAssessmentResults
  },

  computed: {
    main_class() {
      const classes = []

      if (this.current_question_options.length > 4) {
        classes.push('content-overflow')
      }

      return classes
    },

    questions() {
      return this.quiz.questions
    },

    current_question() {
      if (this.quiz.randomize) {
        return this.current_quiz_sorted_questions[this.question_index]
      } else {
        return this.questions[this.question_index]
      }
    },

    current_question_options() {
      if (this.quiz.randomize) {
        const options = this.current_question.options

        return options.slice(0, options.length).sort(function() {
          return 0.5 - Math.random()
        })
      } else {
        return this.current_question.options
      }
    },

    current_question_type() {
      return this.current_question.kind.replace(/_/g, '-')
    },

    current_step() {
      return this.steps[this.step_index]
    },

    is_question_last() {
      return this.quiz.questions.length === (this.question_index + 1)
    },

    is_quiz_finished() {
      return this.current_step === 'results'
    },

    current_quiz_sorted_questions() {
      const questions = this.quiz.questions

      return questions.slice(0, questions.length).sort(function() {
        return 0.5 - Math.random()
      })
    },

    label() {
      if (this.quiz.label) {
        return this.quiz.label
      } else if (this.quiz.type === 'activity_v1_quizzes') {
        return this.$t('quiz')
      } else { // 'activity_v1_self_assessments'
        return this.$t('self_assessment')
      }
    }
  },

  methods: {
    nextStep() {
      this.step_index++
    },

    nextQuestion() {
      if (this.is_question_last) {
        this.submit()
        this.nextStep()
      } else {
        this.question_index++
      }
    },

    retakeQuiz() {
      this.question_index = 0
      this.retake()
    },

    submit() {
      this.updateResult(this.completion_event, this.activity_results)
    },

    stop() {
      this.activity_results = null
      this.step_index = null
    },

    retake() {
      this.completion_event = 'retake'
      this.activity_results = {}
      this.step_index = 0
    }

  }
}
</script>

<style lang='sass'>
  @import './results'
  @import './question-option'
  @import './quiz-pagination'
  @import './question'
  @import './response'
  @import './part-quiz'
</style>
